import React, { useRef } from "react";
import lock from "../../assets/images/lock.png";
import email from "../../assets/images/email.png";

export function ForgetPasswordForm(props) {
	const instanceRef = useRef({ props });
	instanceRef.current.props = props;
	initialConstruct.bind(instanceRef.current)("ForgetPasswordForm", props);

	const { validate, submit, setState: setParent, formref, store } = props;

	return (
		<form
			ref={formref}
			className="popuplogin"
			onSubmit={(e) => submit(e)}
		>
			<div className="title">Forget Password</div>
			<div className="form-input">
				<img src={email} className="icon" />
				<input
					type="text"
					className="input"
					placeholder="Email Address"
					name="email"
					onChange={(e) => validate(e, "email", formref.current)}
					required
				/>
			</div>
			<div className="form-input forgetpassword">
				<label
					className="label"
					onClick={() => setParent({ form: "login" })}
				>
					Sign In
				</label>
			</div>
			<div className="form-input">
				<span style={{ fontWeight: "bold", color: "red", fontSize: "10px" }}>
					{store.errorMsg}<br/>{store.failureMsg}
				</span>
			</div>
			<div className="form-input">
				<button type="submit" className="button" id="signup">
					Submit
				</button>
			</div>
			<div className="form-input">
				Don't have an account?&nbsp;{" "}
				<label
					className="customlable mousepointer"
					onClick={() => setParent({ form: "signup" })}
				>
					{" "}
					Sign Up Now
				</label>
			</div>
		</form>
	);
}

export default ForgetPasswordForm;
